import React, { useContext } from 'react';
import { RicosViewerContext, RicosDirectionContext, RicosNodeContext, RicosNodeContextProvider } from 'ricos-context';
import { TextStyle_TextAlignment } from 'ricos-schema';
import { r as rtlStyles } from '../../../../rtl.rtlignore-09de95fb.js';
import { a as alignmentStyle } from '../../../../alignment.rtlignore-4565cad7.js';
import classnames from 'classnames';
import Anchorable from '../../utils/Anchorable.js';
import { isPaywallSeo, getPaywallSeoClass } from '../../utils/paywallSeo.js';
import { getTextDirection } from 'wix-rich-content-common';

var styles = {"blockStyleSpacing":"_0m06X","codeBlock":"Y2M3U _0m06X","renderedInTable":"TjdzX"};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CodeBlock = ({ node, nodeIndex, RicosNodesRenderer }) => {
  var _a, _b, _c, _d;
  const { seoMode } = useContext(RicosViewerContext);
  const { textDirection } = useContext(RicosDirectionContext);
  const { parentNode } = useContext(RicosNodeContext);
  const { textAlignment, lineHeight } = ((_a = node.codeBlockData) == null ? void 0 : _a.textStyle) || {};
  const codeBlockClassName = classnames(
    styles.codeBlock,
    alignmentStyle[textAlignment || TextStyle_TextAlignment.AUTO],
    rtlStyles[textDirection || getTextDirection((_d = (_c = (_b = node.nodes) == null ? void 0 : _b[0]) == null ? void 0 : _c.textData) == null ? void 0 : _d.text) || "ltr"],
    !parentNode && isPaywallSeo(seoMode) && getPaywallSeoClass((seoMode == null ? void 0 : seoMode.paywall) || {}, nodeIndex)
  );
  const style = lineHeight ? { lineHeight } : {};
  return /* @__PURE__ */ React.createElement(Anchorable, { nodeId: node.id }, /* @__PURE__ */ React.createElement("pre", { className: codeBlockClassName, style }, /* @__PURE__ */ React.createElement(
    "span",
    {
      className: classnames(
        textAlignment === TextStyle_TextAlignment.JUSTIFY && alignmentStyle[textAlignment]
      )
    },
    /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes }))
  )));
};
const CodeBlockRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(CodeBlock, __spreadValues({ key: node.id, node }, props));
};

export { CodeBlockRenderer as default };
//# sourceMappingURL=codeblock.js.map
